import { isFPPErrObj, sendErrorObjToBackendIfNew } from "@newsenec/logging";
import { SenecErrorPage, SenecFPPThemeProvider } from "@newsenec/ui-components";
import { useEffect } from "react";

export type ErrorPageProps = {
    error: unknown;
    /** full name of the micro frontend */
    mfName: string;
    /** micro frontend shorty according to error code convention. */
    mfShorty: string;
};
export const ErrorPage = ({ error, mfName, mfShorty }: ErrorPageProps): JSX.Element => {
    const [errorCode, traceId] = isFPPErrObj(error) ? [error.errorCode, error.errorTraceId] : [undefined, undefined];
    useEffect(() => {
        sendErrorObjToBackendIfNew(mfName, mfShorty, error);
    }, [mfName, mfShorty, error]);

    return (
        <SenecFPPThemeProvider>
            <SenecErrorPage errorCode={errorCode} errorTraceId={traceId} />
        </SenecFPPThemeProvider>
    );
};
